import { Injectable, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

interface TokenResult {
  accessToken: string;
  idToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  /**
   * Get the current access token from the OIDC service
   */
  getAccessToken(): Observable<string | null> {
    return this.oidcSecurityService.getAccessToken().pipe(
      catchError(error => {
        console.error('Error getting access token:', error);
        return of(null);
      })
    );
  }

  /**
   * Get the current ID token from the OIDC service
   */
  getIdToken(): Observable<string | null> {
    return this.oidcSecurityService.getIdToken().pipe(
      catchError(error => {
        console.error('Error getting ID token:', error);
        return of(null);
      })
    );
  }

  /**
   * Get all tokens including access and ID tokens
   */
  getAllTokens(): Observable<TokenResult | null> {
    // Combine both token types into a single observable
    return this.oidcSecurityService.checkAuth().pipe(
      map(authResult => {
        return {
          accessToken: authResult.accessToken,
          idToken: authResult.idToken
        };
      }),
      catchError(error => {
        console.error('Error getting all tokens:', error);
        return of(null);
      })
    );
  }
}
